var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChartColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4c.414 0 .75.317.75.708v13.459h20.25c.414 0 .75.317.75.708v1.417c0 .39-.336.708-.75.708H1.5C.672 21 0 20.366 0 19.583V4.708C0 4.318.336 4 .75 4h1.5zM12.9 5.417c.3 0 .6.283.6.566v8.784c0 .283-.3.566-.6.566h-1.8c-.3 0-.6-.283-.6-.566V5.983c0-.283.3-.566.6-.566zm-4.5 5.666c.3 0 .6.284.6.567v3.117c0 .283-.3.566-.6.566H6.6c-.3 0-.6-.283-.6-.566V11.65c0-.283.3-.567.6-.567zM21.9 4c.3 0 .6.283.6.567v10.2c0 .283-.3.566-.6.566h-1.8c-.3 0-.6-.283-.6-.566v-10.2c0-.284.3-.567.6-.567zm-4.5 4.25c.3 0 .6.283.6.567v5.95c0 .283-.3.566-.6.566h-1.8c-.3 0-.6-.283-.6-.566v-5.95c0-.284.3-.567.6-.567z",
    fill: "#D3D6E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChartColumn);
export default __webpack_public_path__ + "static/media/icon-chart-column.384f0389.svg";
export { ForwardRef as ReactComponent };